module.exports = __webpack_public_path__ + "static/09-7b18483567f8e8a992cacf234f2aaa1b.jpg";